module.exports = __webpack_public_path__ + "img/vertical_4_4_7042.9b879cde.png";